/**
 * DeliverFresh Premium Cart Drawer
 * Features: Free shipping progress bar ($200), minimum order ($50),
 * smooth slide animation, backdrop blur overlay, remove button per item.
 */
(function () {
  'use strict';

  var FREE_SHIPPING_THRESHOLD = 20000; // $200.00 in cents
  var MIN_ORDER_THRESHOLD = 5000;      // $50.00 in cents
 var MAX_QTY_PRODUCTS = {
   'banana-leaves-special-pack-kg': 1,
  'bananas-special-1-kg': 1
}; 

  var overlay = document.getElementById('df-cart-overlay');
  var drawer = document.getElementById('df-cart-drawer');
  var closeBtn = document.getElementById('df-cart-drawer-close');
  var continueBtn = document.getElementById('df-cart-drawer-continue');
  var itemsContainer = document.getElementById('df-cart-drawer-items');
  var countEl = document.getElementById('df-cart-drawer-count');
  var subtotalEl = document.getElementById('df-cart-drawer-subtotal');
  var headerCartCount = document.getElementById('df-header-cart-count');
  var shippingBar = document.getElementById('df-cart-shipping-bar');
  var shippingText = document.getElementById('df-cart-shipping-text');
  var shippingFill = document.getElementById('df-cart-shipping-fill');
  var minOrderWarn = document.getElementById('df-cart-min-warning');
  var checkoutBtn = document.getElementById('df-cart-checkout-btn');
  var currentCart = null;

  if (!drawer || !overlay) return;

  /* ---------- Open / Close ---------- */
  function openDrawer() {
    overlay.classList.add('df-cart-open');
    drawer.classList.add('df-cart-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    overlay.classList.remove('df-cart-open');
    drawer.classList.remove('df-cart-open');
    document.body.style.overflow = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (continueBtn) continueBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('df-cart-open')) {
      closeDrawer();
    }
  });

  /* ---------- Format money ---------- */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------- Update shipping bar ---------- */
  function updateShippingBar(totalPrice) {
    if (!shippingBar) return;

    if (totalPrice >= FREE_SHIPPING_THRESHOLD) {
      shippingText.innerHTML = '<span style="color:#1a3d2b;font-weight:700;">&#127881; You\'ve unlocked FREE SHIPPING!</span>';
      shippingFill.style.width = '100%';
      shippingFill.style.background = '#1a3d2b';
    } else {
      var remaining = FREE_SHIPPING_THRESHOLD - totalPrice;
      var pct = Math.min(100, (totalPrice / FREE_SHIPPING_THRESHOLD) * 100);
      shippingText.innerHTML = '&#128666; Spend <strong>' + formatMoney(remaining) + '</strong> more for <strong style="color:#1a3d2b;">FREE SHIPPING</strong>';
      shippingFill.style.width = pct + '%';
      shippingFill.style.background = pct > 60 ? '#7bc043' : '#f4a135';
    }
  }

  /* ---------- Update min order warning ---------- */
  function updateMinOrder(totalPrice) {
    if (!minOrderWarn || !checkoutBtn) return;

    if (totalPrice > 0 && totalPrice < MIN_ORDER_THRESHOLD) {
      minOrderWarn.style.display = 'flex';
      checkoutBtn.classList.add('df-checkout-disabled');
      checkoutBtn.setAttribute('aria-disabled', 'true');
      checkoutBtn.onclick = function(e) { e.preventDefault(); return false; };
    } else {
      minOrderWarn.style.display = 'none';
      checkoutBtn.classList.remove('df-checkout-disabled');
      checkoutBtn.removeAttribute('aria-disabled');
      checkoutBtn.onclick = null;
    }
  }

  /* ---------- Render cart ---------- */
  function renderCart(cart) {
     currentCart = cart;
    // Update counts
    if (countEl) countEl.textContent = cart.item_count;
    if (headerCartCount) headerCartCount.textContent = cart.item_count;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    // Update all cart bubble elements
    document.querySelectorAll('.df-cart-bubble').forEach(function (el) {
      el.textContent = cart.item_count;
    });

    // Check if cart has Craigieburn Weekender product — skip standard rules
    var hasCraigieburn = false;
    cart.items.forEach(function(item){
      if(item.product_title && item.product_title.toLowerCase().indexOf('weekender') !== -1) hasCraigieburn = true;
      if(item.properties && item.properties['_Order Type'] && item.properties['_Order Type'].indexOf('Craigieburn') !== -1) hasCraigieburn = true;
    });

    if(hasCraigieburn){
      // Skip min order + show FREE delivery
      if(minOrderWarn) minOrderWarn.style.display = 'none';
      if(checkoutBtn){ checkoutBtn.classList.remove('df-checkout-disabled'); checkoutBtn.removeAttribute('aria-disabled'); checkoutBtn.onclick = null; }
      if(shippingBar && shippingText){ shippingText.innerHTML = '<span style="color:#1a3d2b;font-weight:700;">🚚 FREE Home Delivery — Craigieburn Special</span>'; if(shippingFill){ shippingFill.style.width='100%'; shippingFill.style.background='#1a3d2b'; } }
    } else {
      updateShippingBar(cart.total_price);
      updateMinOrder(cart.total_price);
    }

    if (!itemsContainer) return;

    if (cart.items.length === 0) {
      itemsContainer.innerHTML = '<div class="df-cart-drawer-empty"><div style="font-size:48px;margin-bottom:16px;">&#128722;</div><p style="font-size:16px;font-weight:600;color:#1a3d2b;margin-bottom:4px;">Your cart is empty</p><p style="font-size:13px;color:#6b7280;">Start shopping to add items</p></div>';
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var imgSrc = item.image ? item.image.replace(/(\.\w+)(\?|$)/, '_120x$1$2') : '';
      var variantTitle = item.variant_title ? '<span class="df-cart-drawer-item-variant">' + item.variant_title + '</span>' : '';

      html += '<div class="df-cart-drawer-item" data-key="' + item.key + '">';
      html += imgSrc ? '<img src="' + imgSrc + '" alt="" class="df-cart-drawer-item-img">' : '<div class="df-cart-drawer-item-img df-cart-no-img"></div>';
      html += '<div class="df-cart-drawer-item-info">';
      html += '<a href="' + item.url + '" class="df-cart-drawer-item-title">' + item.product_title + '</a>';
      html += variantTitle;
           var maxQty = MAX_QTY_PRODUCTS[item.handle];
      var atLimit = maxQty && item.quantity >= maxQty;

      html += '<div class="df-cart-drawer-item-qty">';
      html += '<button class="df-cart-qty-btn" data-key="' + item.key + '" data-action="minus">&#8722;</button>';
      html += '<span>' + item.quantity + '</span>';
      html += '<button class="df-cart-qty-btn' + (atLimit ? ' df-cart-qty-btn-disabled' : '') + '" data-key="' + item.key + '" data-action="plus"' + (atLimit ? ' disabled' : '') + '>+</button>';
      html += '</div>';
      if (atLimit) {
        html += '<div class="df-cart-drawer-item-limit-note">Max ' + maxQty + 'kg per customer</div>';
      }
      html += '</div>';
      html += '<div class="df-cart-drawer-item-right">';
      html += '<div class="df-cart-drawer-item-price">' + formatMoney(item.final_line_price) + '</div>';
      html += '<button class="df-cart-remove-btn" data-key="' + item.key + '" title="Remove item">&times;</button>';
      html += '</div>';
      html += '</div>';
    });

    itemsContainer.innerHTML = html;
  }

  /* ---------- Fetch cart and render ---------- */
  function fetchAndRender() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      });
  }

  /* ---------- Change item quantity ---------- */
  function changeQuantity(key, quantity) {
        var cartItem = currentCart && currentCart.items.find(function (it) { return it.key === key; });
    var maxQty = cartItem ? MAX_QTY_PRODUCTS[cartItem.handle] : null;
    if (maxQty && quantity > maxQty) {
      quantity = maxQty;
    }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCart(cart);
      })
      .catch(function (err) {
        console.error('Cart change error:', err);
      });
  }

  // Quantity button and remove button delegation
  if (itemsContainer) {
    itemsContainer.addEventListener('click', function (e) {
      // Handle qty buttons
            var btn = e.target.closest('.df-cart-qty-btn');
      if (btn) {
        var key = btn.dataset.key;
        var action = btn.dataset.action;
        var qtySpan = btn.parentElement.querySelector('span');
        var currentQty = parseInt(qtySpan.textContent, 10);

        if (action === 'plus') {
          var cartItem = currentCart && currentCart.items.find(function (it) { return it.key === key; });
          var maxQty = cartItem ? MAX_QTY_PRODUCTS[cartItem.handle] : null;
          if (maxQty && currentQty >= maxQty) {
            return; // blocked — limit reached
          }
          changeQuantity(key, currentQty + 1);
        } else if (action === 'minus') {
          changeQuantity(key, Math.max(0, currentQty - 1));
        }
        return;
      }

      // Handle remove buttons
      var removeBtn = e.target.closest('.df-cart-remove-btn');
      if (removeBtn) {
        changeQuantity(removeBtn.dataset.key, 0);
      }
    });
  }

  /* ---------- Intercept add-to-cart forms ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var action = form.getAttribute('action');
    if (!action || action.indexOf('/cart/add') === -1) return;

    var submitter = e.submitter;
    if (submitter && (submitter.name === 'checkout' || submitter.formAction && submitter.formAction.indexOf('/checkout') !== -1)) return;

    e.preventDefault();

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () {
        return fetchAndRender();
      })
      .then(function () {
        openDrawer();
      })
      .catch(function (err) {
        console.error('Add to cart error:', err);
        form.submit();
      });
  });

  /* ---------- Also intercept fetch-based add to cart (Dawn quick-add) ---------- */
  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');

    if (url.indexOf('/cart/add') !== -1) {
      return originalFetch.apply(this, args).then(function (response) {
        var cloned = response.clone();
        cloned.json().then(function () {
          setTimeout(function () {
            fetchAndRender().then(function () {
              openDrawer();
            });
          }, 300);
        }).catch(function () { });
        return response;
      });
    }

    return originalFetch.apply(this, args);
  };

  /* ---------- Cart icon click opens drawer ---------- */
  var cartBtn = document.getElementById('df-header-cart-btn');
  if (cartBtn) {
    cartBtn.addEventListener('click', function (e) {
      e.preventDefault();
      fetchAndRender().then(function () {
        openDrawer();
      });
    });
  }

  /* ---------- Initial load ---------- */
  fetchAndRender();

  /* ---------- Expose global function for other pages ---------- */
  window.dfRefreshCartDrawer = function(){
    fetchAndRender().then(openDrawer);
  };

})();
